<template>
  <MglMap   :zoom="14" :center="center"  @moveend="moveend"  :accessToken="accessToken"   @load="load"   :mapStyle="mapStyle" >
    <v-btn class="btnLoading" :loading="true" v-show="loading" :x-small="true" fab></v-btn>
    <MglGeocoderControl
    language="fr"
    placeholder="Rechercher une commune"
    :accessToken="accessToken"

   />
   <MglNavigationControl position="top-right" />

  </MglMap>
</template>
<script>
import MglGeocoderControl from 'vue-mapbox-geocoder'
import "mapbox-gl/dist/mapbox-gl.css";

import { MglMap,MglNavigationControl } from "vue-mapbox";
export default {
  components: {  MglMap, MglGeocoderControl,MglNavigationControl },
  props: ['loading','setMap', 'moveend' ],
  data: () => ({
    //center: [2.487880, 46.408241],
    center: [2.343285, 48.860174],
    mapStyle: 'mapbox://styles/mapbox/streets-v11',
    accessToken: 'pk.eyJ1Ijoic2ltb241MSIsImEiOiJjamg4dGUyZXkwNmxuM2NvNmFxN2p5cnpmIn0.G4Igc5WvjFjuIQ6UcuxLOQ',

  }),
  methods: {
    openModal(item) {
      this.$store.dispatch('openDialog', {id: item.id, data: item.data()});
    },
    load(e) {
      this.setMap(e.map);
      setTimeout(() => {
        e.map.resize();
      }, 200);
    }
  }
}
</script>
<style scoped>
@import url('https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-geocoder/v4.5.1/mapbox-gl-geocoder.css');
.btnLoading {
  left: 20px;
  top: 20px;
}
#map-field{
  height: 100%;
  width: 100%;
}
.mgl-map-wrapper {
  height: 100%;
  width: 100%;

}
.mapboxgl-map {
  overflow: visible;
  height: 100% !important;
}
.mapboxgl-canvas {
  height: 100%;

}
</style>
